<template>
  <UnreadMessages
      :messages="messages"
      :uuid="uuid"
      :id="id"/>
</template>

<script>
import DashletsRpc from "@/DashletsRpc";
import DashletConfig from "@/server/com/silkplm/engine/dashboards/DashletConfig";
import UnreadMessages from "@/components/dashlets/UnreadMessages.vue";
import RoutingKeys from "@/server/RoutingKeys";

export default {
  name: "UnreadMessagesDashletForPPSample",
  components: {UnreadMessages},
  async mounted() {
    await this.loadMessages();

    let applicationUser = await Rpc.Users.getSessionUserInfo();
    this.$subscribe(RoutingKeys.RK_CHAT_CHANGE_REFRESH_SAMPLE_DASHLET_BASE_COMPANIES, async message => {
      await this.loadMessages();
    });
  },

  methods: {
    async loadMessages() {
      this.messages = await this.postprocess(await DashletsRpc.UnreadMessagesDashletForPPSample.loadUnreadMessages());
    },
    async postprocess(rawMessages) {
      return rawMessages;
    },

  },

  props: {
    uuid: {type: String, required: true},
    dashletConfig: {type: DashletConfig},
    config: {type: Object},
    id: {type: Number, required: true},
    selectedMessage: null,
  },

  data() {
    return {
      /**
       * @type {UnreadMessageDashletEntry[]}
       */
      messages: []
    };
  }
};
</script>

<style scoped>
</style>
